import $ from 'jquery';

var Relation = function(parent, data) {
    var self = this;

    self.text = ko.observable(data['text']);
    self.ids = ko.observable(data['ids']);
    self.state = ko.observable(data['state']);

    self.dump = function() {
        return {
            ids: self.ids(),
            state: self.state(),
        };
    };
};

var SubmitLock = function() {
    var self = this;
    self._lock = false;

    self.lock = function() {
        $('.u-save-person, .u-save-person-close').attr('disabled', 'disabled');
        self._lock = true;
    };

    self.unlock = function() {
        $('.u-save-person, .u-save-person-close').removeAttr('disabled');
        self._lock = false;
    };

    self.locked = function() {
        return self._lock;
    };
};

if (!window.submitLock) window.submitLock = new SubmitLock();

export function ReferenceForm(data) {
    var self = this;
    self.saveData = ko.observable();
    var referenceName = data['referenceName'];
    var referenceId = data['referenceId'];
    self.state = ko.observable(data['state']);
    self.isUnlinked = ko.observable(data['isUnlinked']);
    self.relations = ko.observableArray([]);
    self.localities = ko.observableArray(data['localities']);
    self.chosenLocalities = ko.observableArray();
    self.relationsChanged = ko.observable(false);

    self.saveAction = ko.observable();

    self.loadChosenLocalities = function(data) {
        var new_arr = [];
        data.forEach(function(loc) {
            var idx = self.localities().findIndex(object => {
                return (object.id === loc.id && object.name === loc.name && object.model === loc.model);
            });
            new_arr.push(self.localities()[idx])
        });
        self.chosenLocalities = ko.observableArray(new_arr);
    };
    self.loadChosenLocalities(data['chosenLocalities']);

    self.loadRelations = function(data) {
        self.relations(
            data.map(function(r) {
                return new Relation(self, r);
            })
        );
    };
    self.loadRelations(data['relations']);

    self.getRelations = function() {
        var d = JSON.stringify(
            self.relations().map(function(relation) {
                return relation.dump();
            })
        );
        return d;
    };

    self.isClosed = ko.pureComputed(function() {
        return self.state();
    });

    self.applyState = ko.pureComputed(function() {
        return !self.relationsChanged();
    });

    self.getIcon = ko.pureComputed(function() {
        return self.state() ? 'glyphicon glyphicon-lock black' : 'glyphicon glyphicon-pencil black';
    });

    self.onRelationChange = function() {
        self.relationsChanged(true);
        return true;
    };

    self.openEdit = function() {
        $.post('/cabinet/reference/close/', {
            reference: referenceName,
            referenceId: referenceId,
            state: self.state(),
        }).done();
        self.state(false);
    };

    self.closeEdit = function() {
        $.post('/cabinet/reference/close/', {
            reference: referenceName,
            referenceId: referenceId,
            state: self.state(),
        }).done();
        self.state(true);
    };

    self.save = function() {
        self.saveAction('save');
        submitForm();
    };

    self.saveAndExit = function() {
        self.saveAction('save-and-exit');
        submitForm();
    };

    self.saveAndNew = function() {
        self.saveAction('save-and-new');
        submitForm();
    };

    self.deleteObject = function() {
        self.saveAction('delete');
        var dialog = $('<p>Вы уверены, что хотите удалить запись?</p>').dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Да, удалить запись': submitForm,
                'Нет, вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
    };

    var submitForm = function() {
        self.saveData(JSON.stringify(self.chosenLocalities()));
        $('#reference-form').submit();
    };

    var backToEdit = function() {
        $(this).dialog('close');
    };

    self.onRefreshRels = function() {
        $.get(
            '/cabinet/reference/get_relations/' + referenceName + '/' + referenceId + '/',
            function(data) {
                self.loadRelations(data.relations);
            }
        );
        self.relationsChanged(false);
    };

    self.onApplyRels = function() {
        $.post('/cabinet/reference/update_relations/', {
            reference: referenceName,
            relations: self.getRelations(),
        }).done();
        self.relationsChanged(false);
    };

    self.selectAll = function() {
        self.relations().forEach(function(relation) {
            relation.state(true);
        });
        self.relationsChanged(true);
    };

    self.resetAll = function() {
        self.relations().forEach(function(relation) {
            relation.state(false);
        });
        self.relationsChanged(true);
    };
}

var showWarning = true;

export function Reference() {
    if (!$('.u-reference-page').length) {
        return;
    }

    $('.btn-success').on('click', function(e) {
        var self = $(this);
        if (
            $(this)
                .closest('form')
                .data('update') === 'False' &&
            showWarning
        ) {
            e.preventDefault();
            $(
                '<p>Количество связанных персон данного ' +
                    'справочника превышает максимально допустимое для быстрого' +
                    ' перестроения поискового индекса. Операция сохранения будет завершена, ' +
                    'но изменения в индексе вступят в силу только после полной переиндексации ночью.</p>'
            ).dialog({
                closeText: null,
                dialogClass: 'no-close',
                width: 600,
                modal: true,
                show: {effect: 'fadeIn', duration: 300},
                buttons: [
                    {
                        text: 'OK',
                        click: function() {
                            $(this).dialog('close');
                            showWarning = false;
                            self.trigger('click');
                        },
                    },
                ],
            });
        }
    });

    /**
     * триггер отправки формы при смене радиобаттона
     */
    $(function() {
        $('.filter-radio-buttons input[type=radio]').on('change', function(e) {
            $('.form-reference-search').submit();
        });
    });
}
